var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.stack),function(stackitem,i){return _c('router-link',{key:i,class:`stack-item w-100${_vm.stack.length === i + 1 ? ' font-weight-bold' : ''}`,attrs:{"to":stackitem.fullPath},nativeOn:{"click":function($event){return _vm.stackItemClicked(i)}}},[_vm._v(" "+_vm._s(_vm.getTitle(stackitem))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }